import { render, staticRenderFns } from "./PlanoManutencaoItensModal.vue?vue&type=template&id=28cf7156&scoped=true"
import script from "./PlanoManutencaoItensModal.vue?vue&type=script&lang=js"
export * from "./PlanoManutencaoItensModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf7156",
  null
  
)

export default component.exports